import {Box, Typography} from '@mui/material';
import AurButton from '../../common/aur-button/AurButton';
import {ReactComponent as EditIcon} from '../../../assests/svg/edit-icon.svg';
import styles from '../../../styles/components/clientdetails/projectDrawerStyle.module.scss';
import {t} from 'i18next';
import {isBoolean} from 'lodash';

type SectionDetailsHeaderProps = {
  headerText?: string;
  isEdit?: boolean;
  isEditButtonVisible?: boolean;
  isSaveButtonDisabled?: boolean;
  onEditHandler: () => void;
  onCancelHandler: () => void;
  onSaveChangesHandler: () => void;
};

const SectionDetailsHeader = ({
  headerText = '',
  isEdit = false,
  isEditButtonVisible = false,
  isSaveButtonDisabled = true,
  onEditHandler,
  onCancelHandler,
  onSaveChangesHandler,
}: SectionDetailsHeaderProps) => {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box>
          <Typography
            className={`${styles.projectDrawerSectionDetailsHeaderText}`}
          >
            {headerText}
          </Typography>
        </Box>

        {isBoolean(isEdit) && isEdit === false && isEditButtonVisible && (
          <Box>
            <AurButton
              dataTestId={'editButton'}
              type="text"
              startIcon={<EditIcon aria-hidden="true" />}
              size="Medium"
              tabIndex={0}
              ariaLabel={t('clientDetailsPage.projectDrawer.edit')}
              onClick={onEditHandler}
              classNames={`${styles.projectDrawerSectionDetailsEditIconButton}`}
            />
          </Box>
        )}
        {isEdit && (
          <Box sx={{display: 'flex', gap: '16px'}}>
            <AurButton
              dataTestId={'cancelButton'}
              label={t('clientDetailsPage.projectDrawer.cancel')}
              type="exit"
              size="Medium"
              tabIndex={0}
              ariaLabel={t('clientDetailsPage.projectDrawer.cancel')}
              onClick={onCancelHandler}
            />
            <AurButton
              dataTestId={'saveButton'}
              type="continue"
              label={t('clientDetailsPage.projectDrawer.saveChanges')}
              size="Medium"
              tabIndex={0}
              ariaLabel={t('clientDetailsPage.projectDrawer.saveChanges')}
              onClick={onSaveChangesHandler}
              disabled={isSaveButtonDisabled}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default SectionDetailsHeader;
